import { AddressOptions } from "../hooks/query/useAddressOption";
import { Get } from "./apiHelper";

// eslint-disable-next-line import/prefer-default-export
export const getAddressOptions = async (): Promise<AddressOptions[]> => {
  const response = await Get(`/api/getAddressOptions`, true);
  return response?.data as AddressOptions[];
};
